export class FeedItemValues {
    Body: string;
    HasBadWords?: boolean;
    SourceId: number;
    SourceIdentifier?: string;
    Title: string;
    ContentFileId?: number;
    MediaUrl?: string;
}